export enum bsColors {
  primary = 'primary',
  danger = 'danger',
  success = 'success',
  white = 'white',
  warning = 'warning',
}

export const MpiStatus = {
  NOT_STARTED: 'Not Started',
  IN_PROGRESS: 'In Progress',
  SENT: 'Sent',
  VIEWED: 'Viewed',
  COMPLETE: 'Complete',
  DRAFT: 'Draft',
} as const;

export const buttonStatuses = {
  mpi: {
    [MpiStatus.NOT_STARTED]: 'danger',
    [MpiStatus.SENT]: 'success',
    [MpiStatus.VIEWED]: 'success',
    [MpiStatus.COMPLETE]: 'success',
    [MpiStatus.DRAFT]: 'warning',
  },
  quote: {
    'Not Started': 'danger',
    'Advisor In Progress': 'success',
    'Technician In Progress': 'danger',
    'Parts In Progress': 'success',
    Sent: 'success',
    Viewed: 'success',
    Complete: 'success',
    Confirmed: 'success',
  },
  video: {
    'Not Started': 'danger',
    Uploaded: 'success',
    Sent: 'success',
    Viewed: 'success',
  },
};

Object.freeze(buttonStatuses);
